import React from 'react';
import { TrendingUp, Award, Target } from 'lucide-react';
import { SecondaryModuleProps } from '../../types/secondaryModule';
import { SecondaryModuleContainer } from './SecondaryModuleContainer';
export function ClassroomModule({
  moduleId,
  isOpen,
  onClose
}: SecondaryModuleProps) {
  const data = {
    qualityOverview: {
      classTypeDistribution: {
        selfExploration: 45,
        teacherInteractive: 55,
        teacherLed: 5
      },
      teachingStructureOptimization: 76.95,
      thinkingCultivationRate: 78.64,
      studentEngagementIndex: 92.3
    },
    teacherProfile: {
      abilityDistribution: [{
        name: '教学素养',
        score: 75.69
      }, {
        name: '课堂管理',
        score: 74.79
      }, {
        name: '教学设计',
        score: 78.2
      }],
      topTeachers: [{
        name: '政治',
        subject: '政治',
        score: 79.6
      }, {
        name: '生物',
        subject: '生物',
        score: 79.47
      }, {
        name: '化学',
        subject: '化学',
        score: 78.87
      }]
    },
    aiInsights: [{
      type: 'finding' as const,
      content: '本周自主探究型课堂占比提升至45%，较上月增长8个百分点'
    }, {
      type: 'finding' as const,
      content: '学生参与度指数达92.3%，创本学期新高'
    }, {
      type: 'suggestion' as const,
      content: '建议加强教师主导型课堂的互动设计，提升学生参与度'
    }, {
      type: 'suggestion' as const,
      content: '建议组织优秀教师开展公开课，分享高阶思维培养经验'
    }, {
      type: 'prediction' as const,
      content: '预计下月教学质量综合指数将突破80分'
    }]
  };
  return <SecondaryModuleContainer moduleId={moduleId} isOpen={isOpen} onClose={onClose} data-id="element-158">
      <div className="grid grid-cols-3 gap-6" data-id="element-159">
        {/* Left Column */}
        <div className="col-span-2 space-y-6" data-id="element-160">
          {/* Quality Overview */}
          <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-161">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-162">
              <div className="w-1 h-5 bg-[#38BDF8] rounded-full" data-id="element-163"></div>
              教学质量全景
            </h3>
            <div className="grid grid-cols-4 gap-4" data-id="element-164">
              <div className="text-center p-4 bg-white/5 rounded-lg" data-id="element-165">
                <div className="text-3xl font-bold text-[#38BDF8] mb-1" data-id="element-166">
                  {data.qualityOverview.classTypeDistribution.selfExploration}%
                </div>
                <div className="text-sm text-gray-400" data-id="element-167">自主探究型</div>
              </div>
              <div className="text-center p-4 bg-white/5 rounded-lg" data-id="element-168">
                <div className="text-3xl font-bold text-green-400 mb-1" data-id="element-169">
                  {data.qualityOverview.teachingStructureOptimization.toFixed(1)}
                </div>
                <div className="text-sm text-gray-400" data-id="element-170">结构优化度</div>
              </div>
              <div className="text-center p-4 bg-white/5 rounded-lg" data-id="element-171">
                <div className="text-3xl font-bold text-purple-400 mb-1" data-id="element-172">
                  {data.qualityOverview.thinkingCultivationRate.toFixed(1)}
                </div>
                <div className="text-sm text-gray-400" data-id="element-173">思维培养率</div>
              </div>
              <div className="text-center p-4 bg-white/5 rounded-lg" data-id="element-174">
                <div className="text-3xl font-bold text-orange-400 mb-1" data-id="element-175">
                  {data.qualityOverview.studentEngagementIndex.toFixed(1)}%
                </div>
                <div className="text-sm text-gray-400" data-id="element-176">学生参与度</div>
              </div>
            </div>
          </div>

          {/* Teacher Ability Distribution */}
          <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-177">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-178">
              <Target className="w-5 h-5 text-[#38BDF8]" data-id="element-179" />
              教师能力分布
            </h3>
            <div className="space-y-4" data-id="element-180">
              {data.teacherProfile.abilityDistribution.map((ability, index) => <div key={index} data-id="element-181">
                  <div className="flex items-center justify-between mb-2" data-id="element-182">
                    <span className="text-white text-sm" data-id="element-183">{ability.name}</span>
                    <span className="text-[#38BDF8] font-bold" data-id="element-184">
                      {ability.score.toFixed(2)}
                    </span>
                  </div>
                  <div className="h-3 bg-white/5 rounded-full overflow-hidden" data-id="element-185">
                    <div className="h-full bg-gradient-to-r from-[#38BDF8] to-[#0EA5E9] rounded-full" style={{
                  width: `${ability.score}%`
                }} data-id="element-186"></div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Top Teachers */}
          <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-187">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-188">
              <Award className="w-5 h-5 text-[#38BDF8]" data-id="element-189" />
              教师综合能力排名
            </h3>
            <div className="space-y-3" data-id="element-190">
              {data.teacherProfile.topTeachers.map((teacher, index) => <div key={index} className="flex items-center justify-between p-4 bg-white/5 rounded-lg" data-id="element-191">
                  <div className="flex items-center gap-4" data-id="element-192">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg ${index === 0 ? 'bg-yellow-400/20 text-yellow-400' : index === 1 ? 'bg-gray-400/20 text-gray-400' : 'bg-orange-400/20 text-orange-400'}`} data-id="element-193">
                      {index + 1}
                    </div>
                    <div data-id="element-194">
                      <div className="text-white font-medium" data-id="element-195">
                        {teacher.subject}
                      </div>
                      <div className="text-gray-400 text-sm" data-id="element-196">学科名称</div>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-197">
                    <div className="text-2xl font-bold text-[#38BDF8]" data-id="element-198">
                      {teacher.score}
                    </div>
                    <div className="text-gray-400 text-sm" data-id="element-199">综合得分</div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* Right Column: AI Insights */}
        <div className="space-y-6" data-id="element-200">
          <div className="glass-panel p-6 rounded-xl border border-[#0EA5E9]/30 bg-gradient-to-br from-[#0EA5E9]/10 to-transparent" data-id="element-201">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-202">
              <div className="w-8 h-8 rounded-full bg-[#0EA5E9]/20 flex items-center justify-center" data-id="element-203">
                <TrendingUp className="w-5 h-5 text-[#0EA5E9]" data-id="element-204" />
              </div>
              易教智能体洞察
            </h3>
            <p className="text-sm text-gray-400 mb-6" data-id="element-205">
              基于课堂数据分析，易教智能体为您生成以下洞察：
            </p>

            <div className="space-y-4" data-id="element-206">
              <div data-id="element-207">
                <div className="text-sm font-bold text-[#38BDF8] mb-2" data-id="element-208">
                  💡 关键发现
                </div>
                <div className="space-y-2" data-id="element-209">
                  {data.aiInsights.filter(insight => insight.type === 'finding').map((insight, index) => <div key={index} className="text-sm text-gray-300 pl-4 border-l-2 border-[#38BDF8]/30 py-1" data-id="element-210">
                        {insight.content}
                      </div>)}
                </div>
              </div>

              <div data-id="element-211">
                <div className="text-sm font-bold text-green-400 mb-2" data-id="element-212">
                  🎯 建议措施
                </div>
                <div className="space-y-2" data-id="element-213">
                  {data.aiInsights.filter(insight => insight.type === 'suggestion').map((insight, index) => <div key={index} className="text-sm text-gray-300 pl-4 border-l-2 border-green-400/30 py-1" data-id="element-214">
                        {insight.content}
                      </div>)}
                </div>
              </div>

              <div data-id="element-215">
                <div className="text-sm font-bold text-orange-400 mb-2" data-id="element-216">
                  📊 预测趋势
                </div>
                <div className="space-y-2" data-id="element-217">
                  {data.aiInsights.filter(insight => insight.type === 'prediction').map((insight, index) => <div key={index} className="text-sm text-gray-300 pl-4 border-l-2 border-orange-400/30 py-1" data-id="element-218">
                        {insight.content}
                      </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SecondaryModuleContainer>;
}